/**
 * PlanChangeType
 * @export EnumPlanChangeType
 * @enum
 */
enum EnumPlanChangeType {
  FreshSubscription,
  RenewalPlan,
  UpgradePlan,
  DowngradePlan,
}

export default EnumPlanChangeType
